import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'
import { Text, View } from '@react-pdf/renderer'
import PDFDivider from '@/components/ReportPDF/PDFDivider'

const Chapter1Page = ({ reportData, setPage }) => {
  const { reprotDao, secondaryCompanyNickname } = reportData || {}
  const { companyName } = reprotDao || {}

  return (
    <PDFPage title="第一章 本文件資訊之揭露與限制" reportData={reportData}>
      <View
        style={{
          width: '100%',
          height: 5, // 設置分隔線的高度
          backgroundColor: 'black', // 設置顏色為黑色
          marginBottom: 30,
        }}
      >
        <PDFDivider style={{ width: '100%' }} />
      </View>
      <View
        style={{
          marginTop: 20,
        }}
      >
        <Text
          render={({ pageNumber }) => {
            setPage({ chap1: pageNumber })
          }}
        />

        <PDFParagraph>
          {'    '}本文件包含
          <Text>{companyName}</Text>
          (即客戶)執行社交工程郵件演練所取得的相關資訊。
          <Text>{secondaryCompanyNickname}</Text>
          建議採取特別保密措施以保護文件及其內容，且文件的所有副本均將交付予客戶。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}
          資訊安全評估是根據過去的經驗、目前可取得的資訊，和已知的威脅，而這些因素可造成評估過程的不確定性。此外，由於資訊安全是一個不斷發展和變化的領域，
          經<Text>{secondaryCompanyNickname}</Text>
          提供之社交工程郵件演練分析結果進行教育訓練後，並不意味著惡意郵件之攻擊將會隨之停止，請客戶務必加強自身資安意識。此外，此次社交工程所採用的分析結果報告是依據截至本文件產出前已知的惡意郵件攻擊技術。隨著新的惡意郵件攻擊技術的持續發展，本文件中所指出的
          <Text>{companyName}</Text>
          之社交工程的報告分析結果及為了降低該惡意郵件攻擊所需採取的補救措施可能隨之改變。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}此文件是由
          <Text>{secondaryCompanyNickname}</Text>
          製作，其內容之智慧財產權為
          <Text>{secondaryCompanyNickname}</Text>
          所有，並僅提供
          <Text>{companyName}</Text>
          使用。本文件對任何第三方的揭露須遵守
          <Text>{companyName}</Text>和<Text>{secondaryCompanyNickname}</Text>
          之合約及保密協定。
        </PDFParagraph>
      </View>
    </PDFPage>
  )
}

export default Chapter1Page
